<template>
  <vx-card no-shadow>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-2/5 w-full">
        <h2>Danger Zone</h2>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Delete Event</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-button color="danger" @click="confirmDeleteVenueTraining" class="ml-auto mt-2">Delete Event</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  components: {
  },
  props: {
    venueTrainingInstance: Object
  },
  data () {
    return {
      venueTrainingId: ''
    }
  },
  methods: {
    confirmDeleteVenueTraining(){
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete the Event?',
        accept: this.deleteVenueTraining
      })
      },
    deleteVenueTraining(){
      this.$http.delete(process.env.VUE_APP_API +'/VenueTrainings/' + this.venueTrainingId)
        .then((/*resp*/) => {
          this.$vs.notify({
            color:'success',
            title:'Success',
            text:'Event deleted'
          });

          this.$router.push({ name: 'admin-venue-trainings' }).catch(() => {})
        })
        .catch(err => {
          console.log(err)

          this.$vs.notify({
            color:'danger',
            title:'Error',
            text:'Could not delete venue training: ' + err
          });
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    }
  },
  created() {
    this.venueTrainingId = this.$route.params.venueTrainingId;
  }
}
</script>